import React from "react"

function IconDollarMenu({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="dollar-menu"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-dollar-menu"
      {...props}
    >
      <path
        d="M6.691 2.727c.313 0 .572.228.62.527l.009.102-.001 1.264.115.014c.826.115 1.51.413 2.049.893l.174.167.148.163c.572.67.873 1.548.904 2.626l.002.362a.688.688 0 0 1-.586.68l-.102.008a.688.688 0 0 1-.68-.586l-.008-.116-.001-.002c0-.876-.236-1.583-.706-2.13-.465-.54-1.113-.81-1.955-.81-.879 0-1.537.225-1.982.67-.447.447-.67 1.015-.67 1.712 0 .668.196 1.197.588 1.597.366.375 1.063.745 2.086 1.104l.287.098.317.11c1.136.409 1.995.88 2.577 1.414.65.598.975 1.44.975 2.516 0 1.069-.337 1.93-1.01 2.574-.612.586-1.419.943-2.414 1.072l-.137.014.002 1.153c0 .278-.18.513-.43.596l-.097.024-.102.009a.629.629 0 0 1-.62-.527l-.008-.102v-1.141l-.14-.01c-.83-.09-1.557-.343-2.176-.762l-.228-.165-.195-.161c-.726-.635-1.1-1.567-1.113-2.84l.001-.194-.002-.04c0-.343.252-.627.582-.676l.1-.007c.343 0 .627.253.676.582l.004.07.003.001c0 1.052.295 1.797.879 2.247.597.462 1.32.693 2.172.693.881 0 1.57-.228 2.076-.68.503-.451.752-1.018.752-1.712 0-.64-.206-1.157-.622-1.561-.427-.415-1.196-.824-2.299-1.218-1.308-.415-2.282-.918-2.92-1.512-.653-.607-.979-1.46-.979-2.547 0-1.043.325-1.9.974-2.562.593-.604 1.38-.97 2.354-1.095l.128-.014V3.356c0-.278.18-.514.43-.597l.097-.024.102-.008zm14.412 12.297a.655.655 0 0 1 .107 1.3l-.107.01h-8.242a.655.655 0 0 1-.106-1.301l.106-.009h8.242zm0-4.121a.655.655 0 0 1 .107 1.3l-.107.009h-8.242a.655.655 0 0 1-.106-1.3l.106-.01h8.242zm0-4.121a.655.655 0 0 1 .107 1.3l-.107.009h-8.242a.655.655 0 0 1-.106-1.3l.106-.01h8.242z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconDollarMenu
